@if (topics) {
  <div class="px-3 pt-3">
    @if (topics.length === 0) {
      <p-button
        routerLink="/topic/new"
        label="Create Topic"
        severity="secondary"
        icon="pi pi-pen-to-square"
        variant="outlined" />
    } @else {
      <p-floatlabel variant="on">
        <p-select
          id="selectedTopic"
          [options]="filteredParticipating"
          [(ngModel)]="selectedTopic"
          [filter]="topics.length > 5"
          [loading]="isPending"
          filterBy="config.title"
          emptyFilterMessage="No Topics Found"
          emptyMessage="Use the button below to create a new Topic."
          class="w-full md:w-56">
          <ng-template #selectedItem let-selectedTopic>
            {{ selectedTopic.config.title }}
          </ng-template>
          <ng-template let-topic #item>
            {{ topic.config.title }}
          </ng-template>
          <ng-template #footer>
            <p-divider class="m-0" />
            <div class="p-2">
              <p-button
                routerLink="/topic/new"
                label="Create Topic"
                severity="secondary"
                icon="pi pi-pen-to-square"
                size="small"
                fluid
                text />
            </div>
          </ng-template>
        </p-select>
        <label for="selectedTopic">Topic</label>
      </p-floatlabel>
    }
  </div>

  <p-divider />

  @if (topics.length === 0) {
    <div class="flex flex-col items-center justify-center p-8 my-6">
      <div class="mb-4">
        <i class="pi pi-info-circle" style="font-size: 3rem"></i>
      </div>
      <h2 class="text-2xl font-semibold text-gray-800 mb-3">
        Create Your First Topic
      </h2>
      <p class="text-gray-600 text-center mb-6 max-w-md">
        Topics help organize your projects and ideas. Create a topic to get
        started with your creative journey.
      </p>
      <p-button
        routerLink="/topic/new"
        label="Create New Topic"
        icon="pi pi-plus"
        severity="primary"
        class="mt-2"
        variant="outlined" />
    </div>
  } @else {
    <div class="container">
      @switch (projectType) {
        @case ('podcast') {
          <app-new-podcast [topic]="selectedTopic"></app-new-podcast>
        }
        @case ('article') {
          <app-new-article [topic]="selectedTopic"></app-new-article>
        }
        @case ('custom-style') {
          <app-new-custom-style [topic]="selectedTopic"></app-new-custom-style>
        }
        @default {
          <div class="flex flex-col items-center justify-center p-8">
            <div class="text-gray-300 mb-4">
              <i class="pi pi-exclamation-circle" style="font-size: 2.5rem"></i>
            </div>
            <h2 class="text-2xl font-semibold text-gray-700 mb-2">
              Unsupported Project Type
            </h2>
            <p class="text-gray-500 text-center mb-4">
              The selected project type is not currently supported.
            </p>
            <p class="text-sm text-gray-400">
              Please select a different project type or contact support for
              assistance.
            </p>
          </div>
        }
      }
    </div>
  }
} @else {
  <div class="container">
    <div class="px-3 pt-3">
      <div class="w-full md:w-56">
        <p-skeleton height="37px" styleClass="mb-2"></p-skeleton>
      </div>
    </div>

    <p-divider />

    <div class="flex justify-center min-h-screen">
      <div class="w-full py-12 px-18.5">
        <form class="flex flex-col gap-2">
          <p-skeleton
            height="200px"
            width="100%"
            styleClass="rounded-xl mb-2"></p-skeleton>

          <p-skeleton height="20px" width="30%" class="my-2"></p-skeleton>
          <p-skeleton height="45px" width="80%" class="my-2"></p-skeleton>
          <p-skeleton height="18px" width="60%" class="my-2"></p-skeleton>
          <div class="flex gap-2 mt-2">
            <p-skeleton
              height="43px"
              width="110px"
              styleClass="rounded-full"></p-skeleton>
            <p-skeleton
              height="43px"
              width="115px"
              styleClass="rounded-full"></p-skeleton>
          </div>
        </form>
      </div>
    </div>
  </div>
}
